<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useMapGetter } from 'dashboard/composables/store.js';
import { frontendURL, conversationUrl } from 'dashboard/helper/URLHelper';
import Avatar from 'next/avatar/Avatar.vue';

const store = useStore();
const router = useRouter();

const tabs = computed(() => store.getters['conversationTabs/getTabs']);
const currentChat = useMapGetter('getSelectedChat');
const accountId = useMapGetter('getCurrentAccountId');
const activeInbox = useMapGetter('getSelectedInbox');

const navigateToConversation = conversationId => {
  const path = frontendURL(
    conversationUrl({
      accountId: accountId.value,
      activeInbox: activeInbox.value,
      id: conversationId,
    })
  );
  router.push({ path });
};

const removeTab = (e, conversationId) => {
  e.stopPropagation();
  store.dispatch('conversationTabs/removeTab', conversationId);
};
</script>

<template>
  <div
    v-if="tabs.length"
    class="flex items-end gap-0 h-9 bg-n-alpha-black2 px-1 pt-1 overflow-x-auto overflow-y-hidden shrink-0"
  >
    <button
      v-for="tab in tabs"
      :key="tab.conversationId"
      class="relative flex items-center gap-1.5 max-w-[180px] min-w-[100px] h-full px-3 text-xs transition-colors cursor-pointer group shrink-0"
      :class="
        currentChat.id === tab.conversationId
          ? 'bg-n-surface-1 text-n-slate-12 rounded-t-lg shadow-sm z-10'
          : 'text-n-slate-11 hover:bg-n-alpha-black3 rounded-t-lg'
      "
      @click="navigateToConversation(tab.conversationId)"
    >
      <Avatar
        :src="tab.avatarUrl || ''"
        :name="tab.contactName || `#${tab.conversationId}`"
        :size="18"
        rounded-full
        hide-offline-status
        class="shrink-0"
      />
      <span class="truncate font-medium leading-tight">{{
        tab.contactName || `#${tab.conversationId}`
      }}</span>
      <span
        class="i-lucide-x size-3.5 shrink-0 rounded-sm opacity-0 group-hover:opacity-70 hover:!opacity-100 hover:bg-n-alpha-black2 transition-opacity"
        @click="removeTab($event, tab.conversationId)"
      />
    </button>
  </div>
</template>
